import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class GenderService {

 constructor(private ws: PostmethodService) { }

  genderCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "genderMaster");
  }
}
